import SharedBaseService from './shared.base.service'

class SharedDocumentService extends SharedBaseService{

    async checkToken(token) {

        let url = `/api/v1/share/doc/validate/${token}`
        const header = {
            'Content-Type': 'application/json',
        }

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: header,
                credentials: 'same-origin',
            }
        )
        if ( response.ok) {
            return await response.json()
        }
        else if ( response.status == 401) {
            throw Error("401")
        }
    }



}

const sharedDocumentService = new SharedDocumentService();

export default sharedDocumentService;